import {event_getEventsByProps_Api} from 'apis/event'
import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import React, {useContext, useMemo} from 'react'
import EntityList from 'views/AppLocals/EntityList'
import EventItem from 'views/AppLocals/Event/components/EventItem'
import EventEntity from 'views/AppLocals/Event/EventEntity'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import OrganizationContainerContext from '../OrganizationContainerContext'
import useTranslate from '../../../../modules/local/useTranslate'
import {WrapperBlockSider} from "../components/WrapperBlockSider";
import renderPagingLoading from "../../../MainPage/functions/renderPagingLoading";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import {getEventTypeTitle} from "../../../Event/components/EventOverviewSetting";
import getTitle from "../../../../helpers/getTitle";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {ItemInfoWithIcon} from "../OrganizationEntity";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {scrollToRow} from "../../Missal/functions/scrollToRow";
import {FiChevronsRight} from "react-icons/fi";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {BsFillCalendar2DateFill, BsPinMapFill} from "react-icons/bs";
import {event_getUpcomingEventsByProps_Api} from "../../../../apis/event";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import dayjs from "dayjs";

export const OrganizationUpcomingEventBlock = ({}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const history = useHistory()
    const {organization: item} = useContext(OrganizationContainerContext)
    const [id, type] = [getId(item), getType(item)]

    if (_.isEmpty(item)) return null

    return (
        <CustomLazyPaginationWrapper
            sample={2}
            apiInfo={event_getUpcomingEventsByProps_Api}
            renderLoading={renderPagingLoading}
            query={bindQueryParams([{id}, {type}])}
            renderWrap={(children, __, count) => {
                return !!count && (
                    <WrapperBlockSider
                        title="upcoming schedule" titleColor="text-green-700"
                        borderLeft={isLg}
                        borderTop={!isLg}
                        icon={<BsFillCalendar2DateFill size={18} className="text-green-500"/>}>
                        <div className="flex flex-col gap-4">
                            {children}
                        </div>
                    </WrapperBlockSider>
                )
            }}
            renderItem={(e, i) => {
                const getStatus = (time_open, time_close) => {
                    const now = dayjs();
                    const open = dayjs.utc(time_open).local();
                    const close = dayjs.utc(time_close).local();

                    if (now.isBefore(open)) return <span className="font-medium text-green-600 italic">{t('upcoming')}</span>;

                    if (now.isAfter(close)) return <span className="font-medium text-primary-500 italic">{t('closed')}</span>;

                    return <span className="font-medium text-blue-600 italic">{t('ongoing')}</span>;
                };
                return (
                    <div key={i} className="px-3 py-2 background-50 hover:scale-2xs hover:shadow-md rounded-xl">
                        <div className="mb-2 pb-2 border-b flex flex-col">
                            <Link to={getLinkToDetail(e)}
                                  className="font-bold text-base text-color-000 leading-snug max-lines-1 no-underline">
                                {getTitle(e)}
                            </Link>
                            <span className="text-xs text-indigo-400 italic leading-snug tracking-wider">
                            {t(getEventTypeTitle(e?.event_type))}
                        </span>
                        </div>
                        <div className="space-x-1">
                            <BsFillCalendar2DateFill size={12} className="mx-1 text-green-500"/>
                            <span className="text-xs text-gray-700 tracking-wide">
                                {formatSimplifyDate(e?.time_open, 'fullTime')}
                                {' - '}{getStatus(e?.time_open, e?.time_close)}
                            </span>
                        </div>
                        <ItemInfoWithIcon
                            icon={<BsPinMapFill size={12} className="mx-1 text-green-500"/>}
                            value={e?.location_name}
                            className="text-xs italic tracking-wide"
                        />
                    </div>
                )
            }}
            renderLoadMore={() => (
                <span
                    className="flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                    onClick={() => {
                        scrollToRow('contentOrg');
                        history.push(getLinkToDetail(item) + '/events')
                    }}>
                        <span className="text-xs italic">
                            {t('see more')}
                        </span>
                        <FiChevronsRight size={13} className="my-auto"/>
                    </span>
            )}
        />
    )
}

const OrganizationEventList = ({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {organization: item} = useContext(OrganizationContainerContext)

    const [id, type] = [getId(item), getType(item)]

    const apiInfo = event_getEventsByProps_Api

    const lookupKey = useMemo(
        () => [apiInfo.path.replace(':id', id).replace(':type', type)].join('/'),
        [id, type, apiInfo]
    )

    if (_.isEmpty(item)) return null

    return (
        <Wrapper className="flex flex-col gap-6">
            <div className="flex flex-col gap-1">
                <h2 className="font-bold text-xl text-gray-800 tracking-wide uppercase">
                    {t('event')}
                </h2>
                <div className="text-color-300 tracking-wider">
                    {t('event introduction description')}
                </div>
            </div>
            <div className="flex flex-col gap-4">
                <EntityList
                    apiInfo={apiInfo}
                    lookupKey={lookupKey}
                    query={bindQueryParams([{id}, {type}])}
                    RenderItem={EventItem}
                    RenderEntity={EventEntity}
                />
            </div>
            <div className="h-10"/>
        </Wrapper>
    )
}

export default OrganizationEventList
